import React from 'react';
import {FeaturingItem} from './featureItem'
import {featureList} from './mock'

export const Featuring = ({title, data, type, setFieldValue}) =>{

    const [features] = React.useState(featureList)

    return (
        <div className="featuring">
            {features?.length>0 && title && <h3 className="">{title}</h3> }
            <div className="row">
                <div className="col-12">
                    <div className="featuring_list">

                        <ul>
                           {features?.length>0 && features.map((item,i)=>(
                               <FeaturingItem key={'featuring'+i} item={item} />
                           ))}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}


